var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromoPickupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 177,
    viewBox: "0 0 278 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_103_168",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 278,
    height: 177
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 177,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_103_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.027 61.9795L133.353 78.0355L29.3818 47.7023L39.5904 12.7006L132.265 -3.35537L236.236 26.9778L226.027 61.9795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5518 83.9704L84.5627 121.229L39.8015 208.06",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.071 143.516L107.903 155.981L81.299 215.359",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.135 107.69L176.887 92.9275",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.922 112.071L196.122 101.177",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.275 124.714L197.067 112.883",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.338 134.121L191.324 128.145",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5747 16.7724L143.812 43.1862L236.228 27.0557",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.838 43.1888L135.593 72.9806",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoPickupIcon);
export default __webpack_public_path__ + "static/media/promo-pickup-icon.30acf35c147baaa206414bf7baf11bbf.svg";
export { ForwardRef as ReactComponent };